import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import AddTaskModal from "./AddTaskModal";
import AddUpdateJobTypeModal from "./AddUpdateJobTypeModal";
import CalendarFilter from "../../../components/common/CalenderFilter";
import {
  ChangeServiceJobStatus,
  DeleteServiceJob,
  GetServiceJobList,
} from "../../../services/ServiceJobType/ServiceJobTypeApi";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import ConfirmationModal from "../../../components/common/ConfirmationModal";
import SuccessModal from "../../../components/common/SuccessModal";
import ErrorModal from "../../../components/common/ErrorModal";
import PaginationComponent from "../../../components/common/PaginationModal";
import NoResultFoundModel from "../../../components/common/NoDataFound";
import BackButtonSvg from "../../../components/common/BackButtonSvg";
const ServiceJobType = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ModuleName = "Predefined";
  const [errorMessage, setErrorMessage] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    serviceKeyID: location.state?.serviceKeyID,
    KeyID: null,
    Action: null,
    status: null,
    JobName: null,
    Name: location.state?.Name,
  });
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);
  //Common Functions
  const [serviceJobTypeSearch, setServiceJobSearch] = useState("");
  const [serviceJobTypeList, setServiceJobList] = useState([]);
  const [serviceJobTypeListCount, setServiceJobListCount] = useState(-1);
  const [serviceJobTypeCurrentPage, setServiceJobCurrentPage] = useState(1);

  const [isTaskModalOpen, setTaskModalOpen] = useState(false);
  const [isJobTypeModalOpen, setJobTypeModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    if (location.state?.serviceKeyID) {
      GetServiceJobListData(1);
    }
  }, [location.state?.serviceKeyID]);

  useEffect(() => {
    if (isAddUpdateDone) {
      if (location.state?.serviceKeyID) {
        setServiceJobSearch("");

        GetServiceJobListData(1, null);
      }
      setIsAddUpdateDone(false);
    }
  }, [isAddUpdateDone]);

  const handleOpenTaskModal = () => setTaskModalOpen(true);
  const handleCloseTaskModal = () => setTaskModalOpen(false);

  const handleOpenJobTypeModal = () => setJobTypeModalOpen(true);
  const handleCloseJobTypeModal = () => setJobTypeModalOpen(false);

  // Api Service Job Type List
  const GetServiceJobListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetServiceJobList({
        moduleName: ModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? serviceJobTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        serviceKeyID: location.state?.serviceKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setServiceJobListCount(response.totalCount);

        setServiceJobList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  console.log("serviceJobTypeListCount", serviceJobTypeListCount);
  //Confirmation Button Click
  const handleConfirmBtn = async () => {
    setLoader(true);
    if (modelAction === "Delete") {
      try {
        let data = await DeleteServiceJob(
          ModuleName,
          modelRequestData.KeyID,
          authDetails.adminKeyID
        );
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setConfirmationModal(false);
          setIsErrorOpen(true);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    } else if (modelAction === "Status") {
      try {
        let data = await ChangeServiceJobStatus(
          ModuleName,
          modelRequestData.KeyID,
          authDetails.adminKeyID
        );
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setIsErrorOpen(true);
          setConfirmationModal(false);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    }
  };

  //Search Functionality
  const handleSearchFunction = (searchValue) => {
    setServiceJobSearch(searchValue);
    GetServiceJobListData(1, searchValue);
  };
  //Change Page Button
  const HandlePageChange = async (pageNumber) => {
    setServiceJobCurrentPage(pageNumber);
    await GetServiceJobListData(pageNumber);
  };
  return (
    <>
      <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
        <div className="h-full bg-white shadow rounded-lg flex flex-col">
          {/* Header Section */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 15px",
            }}
            className="border-b p-4 overflow-x-auto"
          >
            <div className="flex space-x-1">
              <BackButtonSvg onClick={() => navigate("/configure")} />
              <button
                className={`px-2 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
              >
                Job List
              </button>
            </div>
            <h2 className="text-12   font-semibold mb-6">
              {location.state?.Name}
            </h2>
          </div>
          <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
            {/* Left Side: Select Dropdown */}
            <CalendarFilter
              onDateChange={() => {}}
              toDate={toDate}
              setToDate={setToDate}
              fromDate={fromDate}
              setFromDate={setFromDate}
            />

            {/* Right Side: Search Bar & Add Button */}
            <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
              {/* Search Bar */}
              <div className="relative flex items-center w-full sm:w-64">
                <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                <input
                  type="text"
                  className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                  placeholder="Search Job"
                  value={serviceJobTypeSearch}
                  onChange={(e) => {
                    handleSearchFunction(e.target.value);
                  }}
                />
              </div>

              {/* Add Button */}
              <Tooltip title="Add Job ">
                <button
                  id="addBtn"
                  type="button"
                  onClick={() => {
                    setModelRequestData({
                      ...modelRequestData,
                      KeyID: null,
                      Action: null,
                    });
                    handleOpenJobTypeModal();
                  }}
                  className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                >
                  + Add Job
                </button>
              </Tooltip>
            </div>
          </div>

          {/* Tab Content */}
          {/* <div className="p-4"> */}
          <div className="flex flex-col table_wrapper border border-gray-200">
            <div className="flex-1 max-h-[50vh] overflow-y-auto">
              <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                <thead>
                  <tr className="z-1 sticky top-0 bg-white">
                    <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                      Job
                    </th>
                    <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {serviceJobTypeList.map((jobType, index) => (
                    <tr
                      key={jobType.serviceJobKeyID || index}
                      className="hover:bg-slate-50 border-b border-slate-200"
                    >
                      <td className="whitespace-nowrap text-left p-1">
                        {jobType.serviceJobName}
                      </td>
                      <td className="p-2 whitespace-nowrap text-right pr-2 flex justify-end space-x-4">
                        {/* Edit button */}
                        <Tooltip title="Update Job">
                          <button
                            className="text-[#135EA0] hover:text-[#135EA0] flex items-center"
                            onClick={() => {
                              setModelRequestData({
                                ...modelRequestData,
                                KeyID: jobType.serviceJobKeyID,
                                Action: "Update",
                              });
                              handleOpenJobTypeModal(jobType);
                            }}
                          >
                            <FaEdit className="text-12 mr-1" />{" "}
                            {/* Added margin for spacing */}
                          </button>
                        </Tooltip>

                        {/* Add Task button */}
                        <Tooltip title="Add Task">
                          <button
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all flex items-center"
                            onClick={() => {
                              setModelRequestData({
                                ...modelRequestData,
                                KeyID: jobType.serviceJobKeyID,
                                JobName: jobType.serviceJobName,
                                Action: null,
                              });
                              handleOpenTaskModal(jobType);
                            }}
                          >
                            <span className="mr-1">+ Add Task</span>{" "}
                            {/* Added margin for spacing */}
                          </button>
                        </Tooltip>

                        {/* Delete button */}
                        <Tooltip title="Delete job">
                          <button
                            className="text-gray-400 hover:text-gray-400 flex items-center"
                            onClick={() => {
                              setModelRequestData({
                                ...modelRequestData,
                                Name: jobType.serviceJobName,
                                KeyID: jobType.serviceJobKeyID,
                                status: null,
                              });
                              setModelAction("Delete");
                              setConfirmationModal(true);
                            }}
                          >
                            <FaTrash className="text-12" />
                          </button>
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {serviceJobTypeListCount <= 0 && (
                <NoResultFoundModel totalRecords={serviceJobTypeListCount} />
              )}
            </div>
          </div>
          {/* </div> */}
          {serviceJobTypeListCount > pageSize && (
            <div className="flex justify-end ">
              <PaginationComponent
                totalPages={Math.ceil(serviceJobTypeListCount / pageSize)}
                currentPage={serviceJobTypeCurrentPage}
                onPageChange={HandlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      {/* Task Model */}
      {isTaskModalOpen && (
        <AddTaskModal
          modelRequestData={modelRequestData}
          setIsAddUpdateDone={setIsAddUpdateDone}
          isOpen={isTaskModalOpen}
          onClose={handleCloseTaskModal}
        />
      )}
      {/* AddUpdateJobModel  Model */}
      {isJobTypeModalOpen && (
        <AddUpdateJobTypeModal
          modelRequestData={modelRequestData}
          setIsAddUpdateDone={setIsAddUpdateDone}
          isOpen={isJobTypeModalOpen}
          onClose={handleCloseJobTypeModal}
        />
      )}
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        actionType={modelAction}
        onConfirm={() => handleConfirmBtn()}
        modelRequestData={modelRequestData}
      />
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => setShowSuccessPopupModal(false)}
        modelAction={modelAction}
        actionMessage={
          modelAction === "Status"
            ? "Status has been changed successfully!"
            : modelRequestData.Name
        }
      />
      <ErrorModal
        isOpen={isErrorOpen}
        onClose={() => setIsErrorOpen(false)}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default ServiceJobType;
